import _ from "lodash";

import { useAuthUser } from "@features/auth";
import { useProgramsByOcmIdQuery } from "@features/programs";

import { preOrderOrderSetsParams } from "../ordering/draftOrderSetIdentity";
import { useOrderSetsPaginated } from "../queries/orderSetQueries";

export default function usePreOrderPrograms(orderWindowId: string | undefined) {
  const { id: userId, channel, territory } = useAuthUser();

  const programsQuery = useProgramsByOcmIdQuery(orderWindowId);
  const orderSetQuery = useOrderSetsPaginated(
    preOrderOrderSetsParams({ userId, channel, territory }),
    {
      initialPagesToLoad: 100,
      enabled: !!orderWindowId,
    }
  );

  const { data: orderSets } = orderSetQuery;
  const { data: programs = [] } = programsQuery;

  const orderSetLookup = _.keyBy(orderSets, "program.id");

  const data = programs.map((program) => {
    const orderSet = orderSetLookup[program.id];
    return {
      program,
      orderSet,
    };
  });

  return { data, programsQuery, orderSetQuery };
}
